import { render } from "./DropdownButtons.vue?vue&type=template&id=48c105c0"
import script from "./DropdownButtons.vue?vue&type=script&lang=js"
export * from "./DropdownButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__